import React, { useState } from 'react';
import { useAcademy } from '../AcademyContext';

/**
 * First-login onboarding. Shown when a member is missing a name or an email
 * (e.g. created in the Team Dashboard with only partial details). Pre-fills any
 * data we already have, captures the missing name/email (+ optional WhatsApp
 * number) and saves it to our system, then unlocks the Academy.
 */
const AcademyOnboarding = () => {
  const { member, completeProfile, logout } = useAcademy();
  const [name, setName] = useState((member?.name || '').trim());
  const [email, setEmail] = useState((member?.email || '').trim());
  const [whatsapp, setWhatsapp] = useState((member?.whatsapp || '').trim());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  // Optional: when given, allow international format with digits, spaces and
  // the usual separators. Requires at least a few digits.
  const isValidWhatsapp = (v) => /^\+?[\d\s()-]{6,}$/.test(v);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    if (!name.trim()) {
      setError('Please enter your name.');
      return;
    }
    if (!isValidEmail(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }
    const trimmedWhatsapp = whatsapp.trim();
    if (trimmedWhatsapp && !isValidWhatsapp(trimmedWhatsapp)) {
      setError('Please enter a valid WhatsApp number, or leave it empty.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await completeProfile({ name: name.trim(), email: email.trim(), whatsapp: trimmedWhatsapp });
    } catch (err) {
      setError('Could not save your details. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="ac-gate">
      <div className="ac-gate-card">
        <img
          src="/img/sg_bonusclub_combo_white.png"
          alt="SalesGod · BonusClub"
          className="ac-gate-logo"
        />
        <span className="ac-gate-eyebrow">Welcome</span>
        <h1 className="ac-gate-title">Let’s set up your profile</h1>
        <p className="ac-gate-sub">
          Tell us who you are so we can personalize your Academy and track your progress.
        </p>

        <form className="ac-gate-form" onSubmit={submit}>
          <input
            type="text"
            className="ac-gate-input ac-gate-input-text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            autoComplete="name"
          />
          <input
            type="email"
            className="ac-gate-input ac-gate-input-text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
          <input
            type="tel"
            className="ac-gate-input ac-gate-input-text"
            placeholder="WhatsApp number (optional)"
            value={whatsapp}
            onChange={(e) => setWhatsapp(e.target.value)}
            autoComplete="tel"
          />
          {error && <p className="ac-gate-error">{error}</p>}
          <button type="submit" className="ac-gate-btn" disabled={busy}>
            {busy ? 'Saving…' : 'Enter Academy'}
          </button>
        </form>

        <button type="button" className="ac-gate-text-link" onClick={logout}>
          Use a different key
        </button>
      </div>
    </div>
  );
};

export default AcademyOnboarding;
